"use client"

import { useEffect, useRef } from "react"
import "./tooltip.css"

const Tooltip = ({ children, text, visible }) => {
  const tooltipRef = useRef(null)
  const triggerRef = useRef(null)

  const updatePosition = () => {
    const triggerElement = triggerRef.current
    const tooltipElement = tooltipRef.current

    if (visible && triggerElement && tooltipElement) {
      const rect = triggerElement.getBoundingClientRect()
      const sidebarElement = triggerElement.closest(".psb-sidebar")

      if (!sidebarElement) {
        console.warn("Sidebar element not found for Tooltip positioning.")
        return
      }

      const viewportOffset = window.innerWidth * 0.06
      const tooltipLeft = viewportOffset + rect.left
      const tooltipTop = rect.top + rect.height / 2

      tooltipElement.style.top = `${tooltipTop}px`
      tooltipElement.style.left = `${tooltipLeft}px`
      tooltipElement.style.transform = `translateY(-50%)`
    }
  }

  useEffect(() => {
    updatePosition()

    window.addEventListener("scroll", updatePosition)
    window.addEventListener("resize", updatePosition)

    return () => {
      window.removeEventListener("scroll", updatePosition)
      window.removeEventListener("resize", updatePosition)
    }
  }, [visible, text])

  return (
    <div className="tooltip-wrapper">
      <div ref={triggerRef} className="tooltip-trigger" onMouseEnter={updatePosition}>
        {children}
      </div>
      {visible && (
        <div ref={tooltipRef} className="tooltip">
          <span>{text}</span>
          <div className="tooltip-arrow" />
        </div>
      )}
    </div>
  )
}

export default Tooltip
